import { useQuery } from '@tanstack/react-query'

import { getMerchantGeneralBlockDetail } from '@src/api'
import { DefaultApiGetMerchantGeneralBlockDetailRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchMerchantGeneralBlockDetail = (
  params: DefaultApiGetMerchantGeneralBlockDetailRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.merchantGeneralBlockListId,
    queryFn: () => getMerchantGeneralBlockDetail(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_MERCHANT_GENERAL_BLOCK_DETAIL],
  })
}
